function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "components",
  transform: "translate(-1 -1)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_94",
  "data-name": "Rectangle 94",
  width: 4,
  height: 20,
  transform: "translate(2 2)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_95",
  "data-name": "Rectangle 95",
  width: 4,
  height: 12,
  transform: "translate(18 10)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_96",
  "data-name": "Rectangle 96",
  width: 12,
  height: 4,
  transform: "translate(10 2)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_97",
  "data-name": "Rectangle 97",
  width: 4,
  height: 4,
  transform: "translate(10 18)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_98",
  "data-name": "Rectangle 98",
  width: 4,
  height: 4,
  transform: "translate(10 10)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgComponents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponents);
export default __webpack_public_path__ + "static/media/components.f9bfd588.svg";
export { ForwardRef as ReactComponent };